<template>
    <form class="row" @submit.prevent>
        <SelectOption
                class="col-sm-6"
                id="form-months"
                placeholder="Wybierz miesiąc"
                :options="months"
                v-model="monthSelected"
        />
        <SelectOption
                class="col-sm-6"
                id="form-years"
                placeholder="Wybierz rok"
                :options="years"
                v-model="yearSelected"
        />
        <vs-switch v-model="modeSelected">
            <span slot="on">Zwykły</span>
            <span slot="off">Pełny</span>
        </vs-switch>
        <vs-switch v-model="placeSelected" class="switch-place-view">
            <span slot="on">Według dat</span>
            <span slot="off">Według miejsc</span>
        </vs-switch>
        <vs-switch v-model="archivedSelected" class="switch-archived-view">
            <span slot="on">Wszyscy</span>
            <span slot="off">Aktywni</span>
        </vs-switch>
    </form>
</template>

<script>
    import SelectOption from './SelectOption.vue';
    import Constants from '../constants.js';

    export default {
        name: "YearMonthForm",
        components: {
            SelectOption
        },
        data() {
            return {
                monthSelected: '',
                yearSelected: '',
                modeSelected: false,
                placeSelected: false,
                archivedSelected: false,
                months: [],
                years: [],
            }
        },
        props: {
            minYear: {
                type: Number,
                required: true,
            },
            defaultMonth: {
                type: String
            },
            defaultYear: {
                type: Number
            }
        },
        created() {
            if (this.defaultMonth) {
                this.monthSelected = this.defaultMonth;
            }
            if (this.defaultYear) {
                this.yearSelected = this.defaultYear;
            }
            this.months = moment.localeData('pl').months().slice();
            this.months.push(Constants.get('MONTHLY_OVERVIEW'));

            this.years = Array.from({length: moment().year() - this.minYear + 1}, (v, k) => this.minYear + k);
        },
        watch: {
            monthSelected() {
                let monthSelectedNr = -1;
                if (this.monthSelected !== Constants.get('MONTHLY_OVERVIEW')) {
                    monthSelectedNr = this.months.findIndex((e) => {
                        return e === this.monthSelected;
                    });
                }
                this.$emit('monthSelected', this.monthSelected, monthSelectedNr);
            },
            yearSelected() {
                this.$emit('yearSelected', this.yearSelected);
            },
            modeSelected() {
                this.$emit('modeSelected', this.modeSelected);
            },
            placeSelected() {
                this.$emit('placeSelected', this.placeSelected);
            },
            archivedSelected() {
                this.$emit('archivedSelected', this.archivedSelected)
            }
        }
    }
</script>

<style lang="scss">
    .vs-switch {
        height: 38px;
        width: 118px !important;
        font-size: 2rem;
        margin-left: 15px;
    }

    .switch-place-view {
        width: 188px !important;
    }

    .switch-archived-view {
        width: 130px !important;
        /*margin-left: 10px !important;*/
    }

    .vs-circle-switch {
        width: 34px !important;
        height: 34px !important;
    }

    .vs-switch.vs-switch-active {
        .vs-circle-switch {
            margin-left: calc(100% - 38px);
        }

        &:active .vs-circle-switch {
            margin-left: calc(100% - 38px);
        }
    }
</style>


// WEBPACK FOOTER //
// YearMonthForm.vue?f8e577f2